import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
  X,
} from "lucide-react";

 
export function Footer() {
  const [data, setData] = useState(null);
  const socialIcons = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: Youtube,
  twitter: X, // or TwitterIcon
};
 
useEffect(() => {
  fetch("/wp-json/custom/v1/footer")
    .then(res => res.json())
    .then(data => {
      console.log("FOOTER DATA:", data);
      setData(data);
    })
    .catch(err => console.error("ERROR:", err));
}, []);
 
  if (!data) return null;
 
  return (
       <footer className="pt-12 pb-24 md:pb-12 text-white bg-gray-700">
        <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
 
          {/* LOGO + DESCRIPTION */}
          <div>
            <div className="flex items-center gap-2">
              <Link to="/">
                <img
                  src={data.logo?.url}
                  alt="logo"
                  width={140}
                  height={48}
                  loading="lazy"
                  decoding="async"
                  className="w-[140px] h-[48px] object-contain"
                />
              </Link>
            </div>
            <p className="text-gray-100 mb-4">
              {data.description}
            </p>

            <div className="flex items-center gap-4 mt-5">
              {data.social_media &&
                data.social_media.length > 0 &&
                Object.entries(data.social_media[0]).map(([platform, url]) => {
                  const Icon = socialIcons[platform.toLowerCase()];

                  if (!Icon || !url) return null;

                  return (
                    <a
                      key={platform}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-red-500 transition-colors"
                    >
                      <Icon size={22} />
                    </a>
                  );
                })}
            </div>
          </div>
 
          {/* DISCOVER */}
          <div>
            <h3 className="font-bold text-lg mb-4">Discover Pranaam</h3>
            <ul className="space-y-2">
              {data.discover_links?.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.url}
                    className="text-gray-100 hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
 
          {/* PATIENT CARE */}
          <div>
            <h3 className="font-bold text-lg mb-4">Patient Care</h3>
            <ul className="space-y-2">
              {data.patient_links?.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.url}
                    className="text-gray-100 hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
 
          {/* ACADEMICS */}
          <div>
            <h3 className="font-bold text-lg mb-4">Academics & Research</h3>
            <ul className="space-y-2">
              {data.academic_links?.map((item, i) => (
                <li key={i}>
                  <Link
                    to={item.url}
                    className="text-gray-100 hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
 
          {/* CONTACT */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <address className="not-italic text-gray-100">
              <p className="mb-2">{data.hospital_name}</p>
              <p className="mb-2">{data.address}</p>
              <p className="mb-2">Phone: {data.phone}</p>
              <p className="mb-2 break-words">
                Email: {data.email}
              </p>
            </address>
          </div>
        </div>
 
        {/* COPYRIGHT */}
        <div className="border-t border-white/20 mt-8 pt-8 text-center text-gray-100">
          <p>
            © {new Date().getFullYear()} {data.hospital_name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}